export default {
    props: {
        resourcesDataFormatField: {
            type: String,
            default: undefined,
            kComposite: 'resources.dataFormatField'
        }, 
        resourcesDataColorField: {
            type: String,
            default: undefined,
            kComposite: 'resources.dataColorField'
        }, 
        resourcesDataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'resources.dataSource'
        }, 
        resourcesDataTextField: {
            type: String,
            default: undefined,
            kComposite: 'resources.dataTextField'
        }, 
        resourcesField: {
            type: String,
            default: undefined,
            kComposite: 'resources.field'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGantt/Resources.js